import { fetchPropertyTags } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import { EmptyObject } from 'lib/object/objectUtils'

interface PropertyTagsReturn {
  tags: Array<string> | undefined
  fetching: boolean
}

function usePropertyTags(
  propertyId: string | undefined,
  options: { disabled?: boolean } = EmptyObject,
): PropertyTagsReturn {
  const dispatch = useAppDispatch()

  const propertyTagsState = useAppSelector(state => state.offer.propertyTags[propertyId ?? ''])

  useEffect(() => {
    if (!options.disabled && propertyId) {
      dispatch(fetchPropertyTags(propertyId))
    }
  }, [propertyId, options.disabled, dispatch])

  return {
    tags: propertyTagsState?.tags,
    fetching: propertyTagsState?.fetching ?? !options.disabled,
  }
}

export default usePropertyTags
